import React, { Component } from 'react';
import './Footer.scss';
import footerLogo from './assets/images/intel-logo-footer-dark-gray_64.png';
import facebookImg from './images/u893.png';
import twitterImg from './images/u895.png';
import IntelImg from './images/logo-white-3000px.png';
import lnkImg from './images/u897.png';
import youTubeImg from './images/u899.png';
import InstImg from './images/u901.png';


class Footer extends Component {
	render() {

		return (

			
			<footer id="home-footer" className="hm-footerStyle" data-component="footer">
	<div className="hm-logo-container hidden-xs hidden-sm">
		<img className="footer-logo" src={IntelImg} alt="Intel"
			 title="Intel" />
	</div>
	<div className="hm-component-padding clearfix">
		<div className="home-footer-content clearfix">
			<ul className="hm-footer-links">
				<li className="hm-linksInnerComponenetStyle"><a href="http://www.intel.com/content/www/us/en/company-overview/company-overview.html" target="_blank">Company Information</a></li>
				<li className="hm-linksInnerComponenetStyle"><a href="http://www.intel.com/content/www/us/en/corporate-responsibility/corporate-responsibility.html" target="_blank">Our Commitment</a></li>
				<li className="hm-linksInnerComponenetStyle"><a href="http://www.intel.com/content/www/us/en/blogs-communities-social.html" target="_blank">Communities </a></li>
				<li className="hm-linksInnerComponenetStyle"><a href="http://www.intc.com/" target="_blank">Investor Relations</a></li>
				<li className="hm-linksInnerComponenetStyle"><a href="http://www.intel.com/content/www/us/en/company-overview/contact-us.html" target="_blank">Contact Us</a></li>
				<li className="hm-linksInnerComponenetStyle"><a href="http://newsroom.intel.com/" target="_blank">Newsroom</a></li>
				<li className="hm-linksInnerComponenetStyle"><a href="http://www.intel.com/content/www/us/en/jobs/jobs-at-intel.html" target="_blank"> Jobs</a></li>
			</ul>
			<ul className="hm-footer-links social">
				<li className="hm-linksInnerComponenetStyle "><a href="https://www.facebook.com/Intel" target="_blank" className="" alt="Intel on Facebook">
					<img className="footer-icon" src={facebookImg} alt="Intel on Facebook" />
				</a></li>
				<li className="hm-linksInnerComponenetStyle "><a href="https://twitter.com/intel" target="_blank" className="" alt="Intel on Twitter">
					<img className="footer-icon" src={twitterImg} alt="Intel on Twitter" />
				</a></li>
				<li className="hm-linksInnerComponenetStyle "><a href="https://www.linkedin.com/company/intel-corporation" target="_blank" className="" alt="Intel on LinkedIn">
					<img className="footer-icon" src={lnkImg} alt="Intel on LinkedIn" />
				</a></li>
				<li className="hm-linksInnerComponenetStyle "><a href="https://www.youtube.com/user/channelintel?sub_confirmation=1" target="_blank" className="" alt="Intel on YouTube">
					<img className="footer-icon" src={youTubeImg} alt="Intel on YouTube" />
				</a></li>
				<li className="hm-linksInnerComponenetStyle "><a href="http://www.instagram.com/intel" target="_blank" className="" alt="Intel on Instagram">
					<img className="footer-icon" src={InstImg} alt="Intel on Instagram" />
				</a></li>
			</ul>
			<ul className="hm-footer-links secondary-links">
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="" target="">© Intel Corporation</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="http://www.intel.com/content/www/us/en/legal/terms-of-use.html" target="_blank">Terms of Use</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="http://www.intel.com/content/www/us/en/legal/trademarks.html" target="_blank">*Trademarks</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="http://www.intel.com/content/www/us/en/privacy/intel-privacy-notice.html" target="_blank">Privacy</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="http://www.intel.com/content/www/us/en/privacy/intel-cookie-notice.html" target="_blank">Cookies</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="http://www.intel.com/content/www/us/en/policy/policy-human-trafficking-and-slavery.html" target="_blank">Supply Chain Transparency </a></li>
			
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="{{vm.constants.LINK_TERMS_OF_SALES}}" target="_blank">Intel Terms of Sale</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="http://www.intel.com/content/www/us/en/siteindex.html" target="_blank">Site Map</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="#" target="_blank" data-wap_ref="dns" id="wap_dns">Your Privacy Choices</a></li>
				<li className="hm-secondarylinksInnerComponenentStyle"><a href="https://www.intel.com/content/www/us/en/privacy/privacy-residents-certain-states.html " target="_blank" data-wap_ref="nac" id="wap_nac">Notice at Collection</a></li>

			</ul>
		</div>

	</div>
</footer>

		);
	}
}

export default Footer;
